// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import React from "react";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import { CssBaseline, ThemeProvider } from "@3778.care/goban";
import ReactDOM from "react-dom";

import App from "./App";
import {
  ThemeProvider as CurrentThemeProvider,
  useTheme,
} from "./contexts/theme";
import "./gtm";
import "./services/firebase";
import * as serviceWorker from "./serviceWorker";
import "./util/errorHandler";

const Application = () => {
  const { theme } = useTheme();

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  );
};

ReactDOM.render(
  <React.StrictMode>
    <CurrentThemeProvider>
      <Application />
    </CurrentThemeProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
